<template>
  <div class="card_division margin_left">
    <div>
      <div class="cards_game vertical_division_card">
          <div>
            <div class="bottom_card_some_title" style="position:relative;top:3px;">ONLINE</div>
            <div class="bottom_card_big_center_numbers"><b-icon-people-fill style="position:relative;top:5px;"/>
              <NumberAnimation
                ref="number1"
                :from="500"
                :to="online"
                :duration="2"
                :format="formatNumber"
                autoplay
                easing="linear"
              />
            </div>
          </div>
      </div>
    </div>
    <div>
      <div class="cards_game vertical_division_card">
          <div>
            <div class="bottom_card_some_title" style="position:relative;top:3px;">JOGANDO</div>
            <div class="bottom_card_big_center_numbers"><b-icon-controller style="position:relative;top:5px;"/>
              <NumberAnimation
                ref="number2"
                :from="350"
                :to="playing"
                :duration="3"
                :format="formatNumber"
                autoplay
                easing="linear"
              />
            </div>
          </div>
      </div>
    </div>
    <div>
      <div class="cards_game vertical_division_card">
          <div>
            <div class="bottom_card_some_title" style="position:relative;top:3px;">JOGOS</div>
            <div class="bottom_card_big_center_numbers"><b-icon-joystick style="position:relative;top:5px;"/>
              <NumberAnimation
                ref="number3"
                :from="0"
                :to="gamesPlaying"
                :duration="2"
                :format="formatNumber"
                autoplay
                easing="linear"
              />
            </div>
          </div>
      </div>
    </div>
  </div>

</template>

<script>
import settings from "../settings";
import NumberAnimation from "vue-number-animation";
import { io } from "socket.io-client";
export default {
  components: {
    NumberAnimation
  },
  setup() {},
  data() {
    return {
      online: 0,
      playing: 0,
      gamesPlaying: 0,
      socket: null,
    };
  },
  mounted() {
    this.connectSocket();
  },
  beforeUnmount() {
    if (this.socket) {
      this.socket.close();
    }
  },
  methods: {
    formatNumber(value) {
      return ` ${Math.round(value)}`;
    },
    connectSocket() {
      this.socket = io(settings.socketHost, {
        reconnection: true,
        reconnectionDelay: 3000,
        query: { userId: "panel-admin" },
      });

      this.socket.on("connect", () => {
        console.log("Socket.IO conectado ao painel");
      });

      this.socket.on("onlineCount", (onlineCount, playingCount, gamePlayerCounts) => {
        this.online = onlineCount;
        this.playing = playingCount;
        this.gamesPlaying = gamePlayerCounts ? gamePlayerCounts.length : 0;
      });

      this.socket.on("disconnect", () => {
        console.log("Socket.IO desconectado");
      });

      this.socket.on("connect_error", () => {
        console.log("Socket.IO erro de conexão, usando fallback HTTP");
        this.getUsersStatusFallback();
      });
    },
    async getUsersStatusFallback(){
      let res = await this.axios.get(settings.APIRoutes.getUsersStatus());
      if(res){
        this.online = res.data.online;
        this.playing = res.data.playing;
      }
    }
  }
}
</script>

<style scoped>
.card_division{
  height: 100%;
  min-width: 150px;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 10px;
}

.vertical_division_card{
  padding: 0px !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0px !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.online_uses_p{
  position: relative;
  display: block;
}

.bottom_card_big_center_numbers{
  margin: 0px;
  font-weight: bolder;
  font-size: 25px;
  color: var(--theme)
}

.bottom_card_some_title{
  font-size: 17px;
  color: var(--textColor);
  font-weight: bold;
  margin-bottom: 6px;
}
</style>